import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import './scss/style.scss';
import VeeCard from './components/VeeCard';
import * as serviceWorker from './serviceWorker';
import 'typeface-barlow';
import 'bootstrap';



ReactDOM.render(<VeeCard />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
